import ApiService from "../../services/ApiService";
import { BookingV4Endpoint } from "../../endpoints/booking-v4/BookingV4Endpoint";
import { BookingV4Mapper } from "@/data/persistences/mappers/BookingV4Mapper";
// import { VoucherV4Mapper } from "@/data/persistences/mappers/VoucherV4Mapper";
import { ProductV4Mapper } from "@/data/persistences/mappers/ProductV4Mapper";
import { CommodityV4Mapper } from "@/data/persistences/mappers/CommodityV4Mapper";
import { BookingV4RepositoryInterface } from "@/data/persistences/repositories/contracts/BookingV4RepositoryInterface";
import {
  ManualBookingV4Retail,
  GetEstimationPriceV4,
  // GetBookingVoucherListV4,
  // ValidateBookingVoucherCodeV4,
  // IssueVoucherBookingOtpRequestV4,
  // CancelVoucherBookingReserveRequestV4,
  ProductConfigurationRuleRequestParamsV4,
  RequestListCommodityV4,
  ExchangeRateParamsV4,
  CorporateBookingV4Client
} from "@/data/payload/api/BookingV4Request";
import { SubmitPosterProductApiRequest } from "@/data/payload/api/BookingRequest";
import {
  PayloadPosterProduct,
  EstimationPrice,
  // BookingVoucherList,
  // BookingVoucherItem,
  PosterProduct
} from "@/domain/entities/Booking";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
// import { VoucherBookingOtp } from "@/domain/entities/Voucher";
import { ProductConfigurationRule } from "@/domain/entities/Product";
import { Commodity } from "@/domain/entities/Commodity";
import { Pagination } from "@/domain/entities/Pagination";
import { ExchangeRateBookingV4, SavedPackageBookingV4 } from "@/domain/entities/BookingV4";

// BookingV4ApiRepository — wire HTTP existing ke 9 endpoint existing (mirror BookingApiRepository.ts)
export class BookingV4ApiRepository implements BookingV4RepositoryInterface {
  private service: ApiService;
  private endpoints: BookingV4Endpoint;
  private mapper: BookingV4Mapper;
  // private voucherMapper: VoucherV4Mapper;
  private productMapper: ProductV4Mapper;
  private commodityMapper: CommodityV4Mapper;

  constructor(
    service: ApiService,
    endpoints: BookingV4Endpoint,
    mapper: BookingV4Mapper,
    // voucherMapper: VoucherV4Mapper,
    productMapper: ProductV4Mapper,
    commodityMapper: CommodityV4Mapper
  ) {
    this.service = service;
    this.endpoints = endpoints;
    this.mapper = mapper;
    // this.voucherMapper = voucherMapper;
    this.productMapper = productMapper;
    this.commodityMapper = commodityMapper;
  }

  // GENESIS-19590 — Submit STT
  async addManualBooking(
    payload: ManualBookingV4Retail
  ): Promise<ResponsePayload> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.addManualBooking(),
      undefined,
      payload
    );
    return this.mapper.convertPayloadData(resp);
  }
  async addBookingCorporate(
    payload: CorporateBookingV4Client
  ): Promise<ResponsePayload> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.addBookingCorporate(),
      undefined,
      payload
    );
    return this.mapper.convertPayloadData(resp);
  }

  // GENESIS-19591 — Tariff estimation
  async getEstimationPrice(
    payload: GetEstimationPriceV4
  ): Promise<EstimationPrice> {
    const resp = await this.service.invoke(
      "POST",
      this.endpoints.getEstimationPrice("2"),
      undefined,
      payload
    );
    return this.mapper.convertEstimationPrice(resp);
  }

  /* GENESIS-19592 — Voucher / OTP
  async getBookingVoucherList(
    payload: GetBookingVoucherListV4
  ): Promise<BookingVoucherList> {
    const resp = await this.service.invoke(
      "POST",
      this.endpoints.getBookingVoucherList(),
      undefined,
      payload
    );
    return this.mapper.convertBookingVoucherList(resp);
  }

  async validateBookingVoucherCode(
    payload: ValidateBookingVoucherCodeV4
  ): Promise<BookingVoucherItem> {
    const resp = await this.service.invoke(
      "POST",
      this.endpoints.validateBookingVoucherCode(),
      undefined,
      payload
    );
    return this.mapper.convertBookingVoucherItem(resp.data.data);
  }

  async issueVoucherBookingOtp(
    payload: IssueVoucherBookingOtpRequestV4
  ): Promise<VoucherBookingOtp> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.issueVoucherBookingOtp(),
      undefined,
      payload
    );
    return this.voucherMapper.convertIssueVoucherBookingOtpFromApi(resp);
  }

  async cancelVoucherBookingReserve(
    payload: CancelVoucherBookingReserveRequestV4
  ): Promise<boolean> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.cancelVoucherBookingReserve(),
      undefined,
      payload
    );
    return this.voucherMapper.convertCancelVoucherBookingReserveFromApi(resp);
  }
  */

  // GENESIS-19593 — Product / rule / commodity
  async postToGetPosterProduct(
    payload: PayloadPosterProduct
  ): Promise<PosterProduct[]> {
    const resp = await this.service.invoke(
      "POST",
      this.endpoints.postToGetPosterProduct(),
      {},
      new SubmitPosterProductApiRequest({ payload })
    );
    return this.mapper.convertPosterProductDataFromApi(resp);
  }

  async fetchProductConfigurationRule(
    params: ProductConfigurationRuleRequestParamsV4
  ): Promise<ProductConfigurationRule[]> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.fetchProductConfigurationRule(params),
      {}
    );
    return this.productMapper.convertProductConfigurationRule(resp);
  }

  async getCommodityList(
    params: RequestListCommodityV4
  ): Promise<{ data: Commodity[]; pagination: Pagination }> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getCommodityList(params),
      {}
    );
    return this.commodityMapper.convertCommodityDataFromApi(resp);
  }

  // GENESIS-19589 — Exchange rate (Est. CIPL) — non-blocking: pair kosong / HTTP error -> null, tidak throw
  async getActiveExchangeRate(
    params: ExchangeRateParamsV4
  ): Promise<ExchangeRateBookingV4 | null> {
    try {
      const resp = await this.service.invoke(
        "get",
        this.endpoints.getActiveExchangeRate(params.from, params.to),
        {}
      );
      return this.mapper.convertActiveExchangeRate(resp);
    } catch {
      return null;
    }
  }

  // GENESIS-20970 — Saved package customer (sender-side)
  async getSavedPackage(customerId: number): Promise<SavedPackageBookingV4[]> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getSavedPackage(customerId),
      {}
    );
    return this.mapper.convertSavedPackageFromApi(resp);
  }

  async getSavedPackageDetail(
    customerId: number,
    packageId: number
  ): Promise<SavedPackageBookingV4> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getSavedPackageDetail(customerId, packageId),
      {}
    );
    return this.mapper.convertSavedPackageDetailFromApi(resp);
  }
}
